// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-selection-row:hover {
  background-color: #f6f8fa !important;
}

.field-selection-row .field-hover-overlay {
  display: none;
}

.field-selection-row:hover .field-hover-overlay {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/FieldSelectionRow.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".field-selection-row:hover {\n  background-color: #f6f8fa !important;\n}\n\n.field-selection-row .field-hover-overlay {\n  display: none;\n}\n\n.field-selection-row:hover .field-hover-overlay {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
